
import { Component, Vue, Ref } from 'vue-property-decorator'
import RankTable from './components/rankTable.vue'
import { ReporterService } from '@/services'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'

@Component({
    components: {
        RankTable,
        ScrollTo
    }
})
export default class ReporterRank extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private PageSize = 15
    private pageIndex = 1
    private pageTotal = 0
    private rankRange = {
        DAY: 1,
        WEEK: 2,
        MONTH: 3
    }
    private curRank = this.rankRange.DAY
    private rank = []
    private statEndDate = ''
    private dateRange = {}
    private dateRanges = []
    private curDateRange = ''

    private mounted() {
        this.getRank()
    }
    
    private async getRank() {
        const params = {
            page_index: this.pageIndex,
            page_size: this.PageSize,
            cycle: this.curRank,
            rank_date: this.curDateRange
        }
        const result = await ReporterService.getReporterRank(params)
        if (result.status === 200) {
            this.rank = result.data.reporters
            // 限定最大的显示数量
            this.pageTotal = Math.min(result.data.page_total, 150)
            if (!this.rank.length) this.pageTotal = 0
            this.statEndDate = result.data.stat_at
            this.curDateRange = this.getCurDateRange(result.data.date_ranges)
            this.dateRanges = result.data.date_ranges
        }
    }

    private getCurDateRange(dateRanges: any[]) {
        if (!this.dateRanges.length) {
            return dateRanges[0].start
        }
        return this.curDateRange
    }

    private optionLabel(dateRange: any) {
        const isDay = this.curRank === this.rankRange.DAY
        const isMonth = this.curRank === this.rankRange.MONTH
        let date = ''
        if (isDay || isMonth) {
            date = this.formatDate(dateRange.start)
        } else {
            const start = this.formatDate(dateRange.start)
            const end = this.formatDate(dateRange.end)
            date = start + ' - ' + end
        }
        return date
    }

    private  formatDate(dateString: string) {
        const isDay = this.curRank === this.rankRange.DAY
        const isWeek = this.curRank === this.rankRange.WEEK
        if (isDay || isWeek) {
            const date = new Date(dateString)
            const formatObj = {
                y: String(date.getFullYear()),
                m: String(date.getMonth() + 1),
                d: String(date.getDate())
            }
            if (+formatObj.m < 10) formatObj.m = '0' + formatObj.m
            if (+formatObj.d < 10) formatObj.d = '0' + formatObj.d
            return formatObj.m + '月' + formatObj.d + '日'
        }
        const isMonth = this.curRank === this.rankRange.MONTH
        if (isMonth) {
            const date = new Date(dateString)
            const formatObj = {
                y: String(date.getFullYear()),
                m: String(date.getMonth() + 1)
            }
            if (+formatObj.m < 10) formatObj.m = '0' + formatObj.m
            return formatObj.y + '年' + formatObj.m + '月'
        }
        return dateString
    }

    private matchActive(type: number) {
        return this.curRank === type ? 'primary' : 'default'
    }

    private toggleRank(type: number) {
        this.curRank = type
        this.curDateRange = ''
        this.statEndDate = ''
        this.dateRanges = []
        this.pageIndex = 1
        this.getRank()
    }

    private onCurrentPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getRank)
    }

    private onSelectSortDate(date: string) {
        this.pageIndex = 1
        this.curDateRange = date
        this.getRank()
    }
}
